import React, { useState, useEffect, useRef } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Button,
    Box,
    Stack,
    FormControl,
    Autocomplete,
    TextField,
    Typography,
    TablePagination,
} from "@mui/material";
import "react-datepicker/dist/react-datepicker.css";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from "dayjs";
import { ApiGetClients, ApiGetClientEntities, ApiGetSpentReport, ApiGetClientDbName, ApiGetClientEntityByClientGroupId, ApiGetSpentReportExcel } from "../../../apiService/Core/Apicall.tsx";
import html2pdf from 'html2pdf.js'
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../global/config/store.ts";
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts";
import { ApigetSpentReport, ApigetSpentReportExcel } from "../../../apiService/Core/CustomApiManageReports.tsx";


interface ClientType {
    clientId: number;
    clientName: string;
}
interface ClientEntity {
    clientEntityId: number;
    entityName: string;
}
const SpentReport: React.FC = () => {
    const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
    const dispatch = useDispatch()
    const [startDate, setStartDate] = useState<Dayjs | null>(dayjs().startOf('year'));
    const [endDate, setEndDate] = useState<Dayjs | null>(dayjs());
    const [clients, setClients] = useState<any>([]);
    const [clientEntities, setClientEntities] = useState<ClientEntity[]>([]);
    const [selectedEntityId, setSelectedEntityId] = useState<number | null>(null);
    const [reportData, setReportData] = useState<any[]>([]);
    const [clientGroups, setClientGroups] = useState<any[]>([]);
    const [selectedGroupDbName, setSelectedGroupDbName] = useState<any | null>(selectedClientName);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [datalength, setdatalength] = useState<any>(null);
    const pdfRef = useRef<HTMLDivElement>(null);
    const [totalSpentAmount, setToalSpentAmount] = useState(null)
    const Clientlist = useSelector((state: RootState) => state.client.clientList);

    // useEffect(() => {
    //     const getclientgroupName = async () => {

    //         try {
    //             const res = await ApiGetClientDbName()
    //             setClientGroups(res.data)
    //             setSelectedGroupDbName(res.data.find(item => item.clientGroupName === "MM"))

    //         } catch (error) {
    //             alert(error)
    //         }
    //     }
    //     getclientgroupName()
    // }, [])

    // useEffect(() => {
    //     const getclients = async () => {
    //         if (selectedGroupDbName) {

    //             try {
    //                 const query = `?status=active&clientGroup=${selectedGroupDbName.clientGroupName}`;
    //                 const res = await ApiGetClients(query)
    //                 const mappedClients = res.data.map((client: any) => ({
    //                     clientId: client.ClientID,
    //                     clientName: client.ClientName,
    //                 }));

    //                 setClients(mappedClients);
    //                 setSelectedClient(mappedClients[0])

    //             } catch (error) {
    //                 alert(error)
    //             }
    //         }
    //     }
    //     getclients()
    // }, [selectedGroupDbName])

    // useEffect(() => {
    //     if (Clientlist.length > 2) {
    //         // setSelectedClient(Clientlist[2]);
    //         setSelectedGroupDbName(Clientlist[2]);
    //     }
    // }, [Clientlist]);

    useEffect(() => {
        setSelectedGroupDbName(selectedClientName)
    }, [selectedClientName])
    useEffect(() => {
        // const getcliententities = async () => {
        //     if (selectedGroupDbName) {
        //         const data = `?clientGroupName=${selectedGroupDbName.clientGroupName}&clientEntityStatus=active`;
        //         try {
        //             const res = await ApiGetClientEntities(data);
        //             setClientEntities(res.data || []);
        //             setSelectedEntityId(null); // <== don't auto-select
        //         } catch (error) {
        //             alert(error);
        //             setClientEntities([]);
        //             setSelectedEntityId(null);
        //         }
        //     }
        // }
        // getcliententities()
        if (selectedGroupDbName && selectedGroupDbName?.clientGroupName !== "All") {
            handleGetClientList();
        }
    }, [selectedGroupDbName])

    const handleGetClientList = async () => {
        const data = `?ClientGroupName=${selectedGroupDbName?.clientGroupName}`
        if (!selectedGroupDbName) return
        try {
            const res: any = await ApiGetClientEntityByClientGroupId(data)
            setClientEntities(res.data)
        } catch (error) {
            console.error("Error during API call:", error)
        }
    }

    useEffect(() => {
        getspentreport()

    }, [selectedEntityId, startDate, endDate, page, rowsPerPage, selectedGroupDbName]);

    const getspentreport = async () => {
        setReportData([]);
        const formattedStartDate = startDate ? startDate.format('M/YYYY') : '';
        const formattedEndDate = endDate ? endDate.format('M/YYYY') : '';
        if (selectedGroupDbName && formattedStartDate && formattedEndDate) {
            const data = `?offset=${page * rowsPerPage}&allocationClientGroup=${selectedGroupDbName?.clientGroupName}&limit=${rowsPerPage}${selectedEntityId ? `&clientEntityId=${selectedEntityId}` : ""}&startMonth=${formattedStartDate}&EndMonth=${formattedEndDate}`
            try {
                const res = await ApigetSpentReport(data, selectedGroupDbName?.clientGroupName)
                setReportData(res.data)
                setdatalength(res.totalCount)
                setToalSpentAmount(res?.totalSpent)
            } catch (error) {
                console.log(error);
            }
        }
    }


    // ------------------------------------------- Chnage Pagination -----------------------------------------------
    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const newValue = parseInt(event.target.value, 10);
        setRowsPerPage(isNaN(newValue) ? 5 : newValue);
        setPage(0);
    };

    // const handleDownloadPdf = () => {
    //     if (pdfRef.current) {
    //         const opt = {
    //             margin: 0.5,
    //             filename: 'star-rating.pdf',
    //             image: { type: 'jpeg', quality: 0.98, compression: 'NONE' },
    //             html2canvas: {
    //                 scale: 2,
    //                 useCORS: true,
    //                 letterRendering: true,
    //                 allowTaint: true,
    //                 logging: true,
    //                 backgroundColor: '#FFFFFF',
    //                 ignoreElements: (element) => {
    //                     return element.classList.contains('no-export');
    //                 }

    //             },
    //             jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compress: false },
    //             pagebreak: {
    //                 mode: ['avoid-all', 'css', 'legacy'],
    //                 before: '.page-break-before',
    //                 after: '.page-break-after',
    //                 avoid: '.avoid-break'
    //             }
    //         };

    //         html2pdf()
    //             .set(opt)
    //             .from(pdfRef.current)
    //             .outputPdf('blob')
    //             .then((pdfBlob: Blob) => {
    //                 const blobUrl = URL.createObjectURL(pdfBlob);
    //                 const link = document.createElement("a");
    //                 link.href = blobUrl;
    //                 link.download = "spent-report.pdf";
    //                 document.body.appendChild(link);
    //                 link.click();
    //                 document.body.removeChild(link);
    //                 URL.revokeObjectURL(blobUrl);
    //             })
    //             .catch((err: any) => {
    //                 console.error('PDF generation error:', err);
    //                 toast.error('Failed to generate PDF');
    //             });
    //     }
    // };
    const handleDownloadExcel = async () => {
        try {
            const formattedStartDate = startDate ? startDate.format('M/YYYY') : '';
            const formattedEndDate = endDate ? endDate.format('M/YYYY') : '';
            const data = `?startMonth=${formattedStartDate}&allocationClientGroup=${selectedClientName?.clientGroupName}&EndMonth=${formattedEndDate}${selectedEntityId ? `&clientEntityId=${selectedEntityId}` : ""}`
            const res = await ApigetSpentReportExcel(data, selectedClientName?.clientGroupName);

            const blob = new Blob([res], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const url = URL.createObjectURL(blob);

            const selectedBusiness = clientEntities.find(
                (entity) => entity.clientEntityId === selectedEntityId
            );

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `${selectedGroupDbName?.clientGroupName}${selectedBusiness?.entityName ? `_${selectedBusiness?.entityName}` : ""}_${formattedStartDate}_to_${formattedEndDate}_SpentReport.xlsx`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            toast.error("Error Downloading Excel.")
            console.error("Error Downloading Excel.", error)
        }
    }
    return (
        <Box className="manage-admin-container" padding='20px'>
            <Box sx={{ width: "100%", mt: 1 }}>
                <Box sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "0px",
                }}>
                    <Typography variant="h3" className="common-manage-h1 mb-3" sx={{
                        textAlign: "center",
                        flexGrow: 1,
                        // ml: "200px"
                    }}>
                        Yearly Report
                    </Typography>
                    <Box sx={{
                        height: "40px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}>

                    </Box>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "-59px",
                        marginTop: "21px",
                    }}
                >

                    <Stack direction="row" spacing={2}>
                        <FormControl size="small" sx={{ width: 180, mb: 0 }}>
                            <Autocomplete
                                disablePortal
                                id="group-autocomplete"
                                // options={Clientlist}
                                options={[{ clientGroupName: "All", clientGroupDBName: "All" },...Clientlist]}
                                value={selectedGroupDbName}
                                getOptionLabel={(option: any) => option.clientGroupName || ""}
                                isOptionEqualToValue={(option: any, value: any) => option.clientGroupDBName === value.clientGroupDBName}
                                onChange={(event, value) => {
                                    // setSelectedGroupDbName(value);
                                    if(value?.clientGroupName === "All"){
                                        setSelectedGroupDbName(value)
                                    }else{
                                    dispatch(setSelectedClientGroup(value))
                                    }
                                    setClientEntities([]);
                                    setSelectedEntityId(null);
                                    setReportData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Client" />
                                )}
                                size="small"
                            />
                        </FormControl>
                        <FormControl size="small" sx={{ width: 185 }}>
                            <Autocomplete
                                disablePortal
                                id="mm-autocomplete"
                                options={clientEntities}
                                getOptionLabel={(option: any) => option.entityName}
                                value={clientEntities.find((entity) => entity.clientEntityId === selectedEntityId) || null}
                                onChange={(event: any, value: ClientEntity | null) => {
                                    setSelectedEntityId(value?.clientEntityId || null);
                                    setReportData([]);
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} label="Select Business" />
                                )}
                                size="small"
                            />
                        </FormControl>
                    </Stack>
                    <Stack direction="row" spacing={2}>
                        <Button variant="contained" sx={{ backgroundColor: "#75724C", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}
                            onClick={handleDownloadExcel}>
                            DOWNLOAD AS XLSX
                        </Button>
                        {/* <Button variant="contained" sx={{ backgroundColor: "#75724C", borderRadius: "8px", px: 3, "&:hover": { backgroundColor: "#5a522c" } }}
                            onClick={handleDownloadPdf}>
                            DOWNLOAD AS PDF
                        </Button> */}
                    </Stack>
                </Box>
            </Box>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "20px",
                    mb: 2
                }}
            >
                <Box display="flex" alignItems="center" gap={2} marginLeft={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={['year', 'month']}
                            label="Start Month"
                            openTo="month"
                            value={startDate}
                            onChange={(newValue) => {
                                setStartDate(newValue);
                                if (!newValue) {
                                    setEndDate(null);
                                }
                            }}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    sx: {
                                        width: 180,
                                        '& .MuiInputBase-root': { height: 40 }
                                    }
                                }
                            }}
                        />
                    </LocalizationProvider>

                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            views={['year', 'month']}
                            label="End Month"
                            openTo="month"
                            value={endDate}
                            onChange={(newValue) => setEndDate(newValue)}
                            minDate={startDate || undefined}
                            disabled={!startDate}
                            slotProps={{
                                textField: {
                                    size: 'small',
                                    sx: {
                                        width: 180,
                                        '& .MuiInputBase-root': { height: 40 }
                                    }
                                }
                            }}
                        />
                    </LocalizationProvider>
                </Box>
            </Box>
            <Box className='w-100 border-10 mb-3' sx={{ bgcolor: '#75724C1A', overflow: 'hidden' }}>
                <Box className='p-3 d-flex align-items-center justify-content-between' sx={{ borderTop: '3px solid #75724C' }}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Total Spent:</Typography>
                    <Typography variant="h5" sx={{ fontWeight: 'bold' }}>${totalSpentAmount}</Typography>
                </Box>
            </Box>
            {selectedClientName && startDate && endDate && (
                <Box ref={pdfRef}>

                    <Table sx={{ width: "100%", tableLayout: "fixed" }}>
                        <TableHead>
                            <TableRow className="table-row-background">
                                <TableCell style={{ width: '20%', color: "#fff", fontWeight: "bold", textAlign: "left" }}>Group Name</TableCell>
                                <TableCell style={{ width: '10%', color: "#fff", fontWeight: "bold", textAlign: "left" }}>Site / Store Name</TableCell>
                                <TableCell style={{ width: '20%', color: "#fff", fontWeight: "bold", textAlign: "center" }}>Month</TableCell>
                                <TableCell style={{ width: '5%', color: "#fff", fontWeight: "bold", textAlign: "start" }}>Type</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Food</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Bar</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Gaming</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Bottle Shop</TableCell>
                                <TableCell style={{ color: "#fff", fontWeight: "bold", textAlign: "center" }}>Total Spent</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {reportData?.length > 0 ? reportData.map((report: any, index: number) => (
                                <TableRow>
                                    <TableCell style={{ textAlign: "left" }}>{report.clientName}</TableCell>
                                    <TableCell style={{ textAlign: "left" }}>{report.venueName}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.reportMonth}/{report.reportYear}</TableCell>
                                    <TableCell style={{ textAlign: "start" }}>{report.shopTypeName}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentFoodAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentBarAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentBottleShopAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.spentGamingAmt}</TableCell>
                                    <TableCell style={{ textAlign: "center" }}>{report.totalSpent}</TableCell>
                                </TableRow>
                            )) : <TableRow><TableCell colSpan={9} className="text-center"><Typography>No Data Found </Typography></TableCell></TableRow>}
                        </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        component="div"
                        count={datalength}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Box>
            )}
        </Box>
    );
};

export default SpentReport;